// Resolved values from the :export block in _0colors.scss.
// Consumed by deprecated icon/illustration components in lib/ that need color
// values as JS strings. Do not add new consumers — use design tokens instead.
const colors = {
  x_brand: '#123243',
  x_primary_action: '#008599',
  x_secondary_action: '#35596d',
  x_brand_light: '#5d7b8a',
  x_primary_light: '#4ca9b7',
  x_secondary_light: '#5d7b8a',
  x_secondary_light_50: '#80a2b4',
  x_brand_dark: '#123243',
  x_primary_dark: '#007081',
  x_secondary_dark: '#123243',
  x_primary_highlight: '#4ca9b7',
  x_secondary_highlight: '#5d7b8a',
  x_primary_teal4: '#017A8F',
  x_success: '#429672',
  x_alert: '#c64e4e',
  x_alert_dark: '#b63131',
  x_alert_warning: '#FFF1D6',
  x_gentle_notification: '#35596d',
  x_highlight: '#ca7602',
  x_success_dark: '#2a7a58',
  x_soft_purple: '#ae5b89',
  x_soft_black: '#343a40',
  primary_action_lyra_select: '#444FB4',
  primary_dark_lyra_select: '#364096',
  x_dark_gray: '#343a40',
  x_semi_dark_gray: '#687078',
  x_medium_gray: '#878d97',
  x_light_gray_100: '#babec3',
  x_light_gray_70: '#d1d4d7',
  x_light_gray_40: '#d1d4d7',
  x_light_gray_10: '#f1f3f5',
  x_white: '#ffffff',
  x_navy1: '#d6e3eb',
  x_navy3: '#5d7b8a',
  x_navy4: '#35596d',
  x_navy5: '#22485c',
  x_navy6: '#123243',
  x_educated_suggestion: '#f2dce8',
  x_educated_suggestion_text: '#852e5e',
  x_dark_purple: '#9e4275',
  x_red1: '#f9ebeb',
  x_red2: '#eaafaf',
  x_red4: '#c64e4e',
  x_red5: '#b63131',
  x_red6: '#982a2a',
  x_warning: '#ca7602',
  x_warning_dark: '#ad5700',
  x_teal1: '#d6eaed',
  x_teal3: '#4ca9b7',
  x_teal5: '#007081',
  x_orange1: '#f9f1e5',
  x_orange3: '#d99e4d',
  x_orange5: '#ad5700',
  x_orange8: '#ffd793',
  x_green1: '#edf4f1',
  x_green4: '#429672',
  x_marine: '#133D54',
  x_marine400: '#7E9FB0',
  x_marine100: '#E9EFF2',
  x_aqua: '#368D9B',
  x_aqua400: '#89BEC6',
  x_aqua100: '#E0EEF0',
  x_sage: '#36745A',
  x_sage400: '#9ABFAF',
  x_sage100: '#E8F2EE',
  x_sahara: '#B68952',
  x_sahara400: '#D2B898',
  x_sahara100: '#F7F0E7',
  x_persimmon: '#B55C53',
  x_persimmon400: '#D1928C',
  x_persimmon100: '#F6E9E8',
  x_plum: '#852E5E',
  x_plum400: '#BD7CA0',
  x_plum100: '#E7D5DF',
  x_yosemite: '#2F3335',
  x_teton: '#B6B8BA',
  x_purple1: '#f2dce8',
  x_purple5: '#9e4275',
  ui_oatmeal_1: '#FBFAF9',
  ui_oatmeal_2: '#F5F2EE',
  ui_oatmeal_3: '#DFDBD6',
  ui_oatmeal_4: '#8F8A85',
  ui_oatmeal_5: '#4F4D4A',
  ui_oatmeal_6: '#1A1918',
  secondary_peach1: '#FFF3F0',
  secondary_peach2: '#FCD0C2',
  secondary_peach3: '#FCB097',
  secondary_peach4: '#D96D4A',
  secondary_peach5: '#B84C33',
  secondary_peach6: '#8F3424',
  error_red5: '#BA455B',
  'primary-action-lyra-select': '#444FB4',
  primary_action_aurora: '#06163B',
  primary_light_action_aurora: '#0E3C76',
  divider_primary_aurora_light: 'rgba(31, 87, 158, 0.5)',
  text_secondary_aurora_light: '#0E3C76',
}

export default colors
